/** Created by azhou on 2019/3/14.*/
<template>
  <div>
    <public-title showBack>{{discountId?'编辑':'添加'}}促销信息</public-title>
    <div class="load-area">
      <left-text-border class="mb-3" leftText="促销标题" v-model="discountInfo.title" required/>
      <div class="d-center-start mb-3">
        <left-text leftText="展示时间" required/>
        <el-date-picker v-model="timestamp"
                        style="width: 100%;"
                        type="daterange"
                        range-separator="至"
                        value-format="timestamp"
                        :picker-options="startDateLimit"
                        size="small"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"/>
      </div>
      <div class="d-start-start mb-4">
        <left-text leftText="促销内容" required/>
        <!-- 富文本框于2020-05-28下午注释。方便滚动条文字展示，将富文本编辑器换成文本框-->
        <!-- <rich-editor class="w-100" v-model="discountInfo.content" :contentProps="discountInfo.content"/> -->
        <el-input type="textarea" class="w-100" v-model="discountInfo.content" :maxlength="200" />
      </div>
      <el-button type="primary" @click="submitForm('store')" v-if="userInfo.type!==99">提交</el-button>
      <div  v-if="userInfo.type===99 && !discountInfo.status">
        <el-button type="success" @click="submitForm('1')">同意发布</el-button>
        <el-button type="danger" @click="submitForm('0')">拒绝发布</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapMutations, mapActions, mapState } from 'vuex'
  import RichEditor from '../../../components/Editor/RichEditor'

  export default {
    name: 'addEditDiscount',
    components: { RichEditor },
    data () {
      return {
        discountInfo: {},
        timestamp: '',
      }
    },
    computed: {
      ...mapState(['discountDetail']),
      ...mapGetters(['userInfo']),
      storeId () {
        return this.$route.query.store
      },
      discountId () {
        return this.$route.query.discount
      },
      //活动开始时间戳
      startDateLimit () {
        return {
          disabledDate (time) {
            return time.getTime() < Date.now() - 8.64e7
          }
        }
      },
    },
    watch: {
      discountDetail () {
        this.discountInfo = { ...this.discountDetail };
        this.discountInfo.content = this.repalceHtml(this.discountInfo.content)
        this.timestamp = [this.discountInfo.startdate * 1000,this.discountInfo.enddate * 1000];
      }
    },
    mounted () {
      this.UPDATECURRENTSTORE({ storeId: this.storeId })
      if (this.discountId) this.getDiscountDetail(this.discountId)
    },
    destroyed () {
      this.UPDATECURRENTSTORE({ storeId: '' })
    },
    methods: {
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['getDiscountDetail', 'addEditDiscount','verifyItem']),
      repalceHtml(str){
        let dd = str.replace(/<\/?.+?>/g,"");
        return dd.replace(/ /g,"");
      },
      validateForm() {
        if (!this.discountInfo.title) return {code:false,msg:'请填写活动名称'}
        if (!this.timestamp) return {code:false,msg:'请设置活动时间'}
        if (!this.discountInfo.content) return {code:false,msg:'请填写活动内容'}

        return {code:true,msg:'验证成功'}
      },
      submitForm (flag) {
        let res = this.validateForm();
        if (res.code) {
          this._confirm('确认提交操作么？',async () => {
            this.discountInfo.startdate = this.timestamp[0] / 1000;
            this.discountInfo.enddate = this.timestamp[1] / 1000;
            //this.discountInfo.content = await this.$GFUN.formatEditor(this.discountInfo.content)
            if (flag === 'store') {      //门店添加删除操作
              this.addEditDiscount({
                type: this.discountId ? 'edit' : 'add',
                data:{
                  ...this.discountInfo,
                  onsale_id:this.discountInfo.id
                }
              })
            } else {        //管理员审核
              this.verifyItem({
                type:'hotelActi',
                data:{
                  ...this.discountInfo,
                  status:flag == 0 ? '2' : '1'
                }
              })
            }
          })
        } else this._alert(res.msg,null,'error');
      },
    }
  }
</script>
